import { render, staticRenderFns } from "./file-input.vue?vue&type=template&id=464f79e7&scoped=true&lang=pug&"
import script from "./file-input.vue?vue&type=script&lang=js&"
export * from "./file-input.vue?vue&type=script&lang=js&"
import style0 from "./file-input.vue?vue&type=style&index=0&id=464f79e7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464f79e7",
  null
  
)

export default component.exports